import { ClickAwayListener } from '@mui/material';
import React, { useEffect, useRef } from 'react';
// import { useClickAway } from '../../../hooks/useClickAway';
import { handleKeyEvent } from '../../../util/events.util';
import ModalBackdrop from './ModalBackdrop';

interface ModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  children: React.ReactNode;
  blur?: string;
}

export default function Modal({ open, setOpen, children, blur }: ModalProps) {
  const ref = useRef<HTMLDialogElement>(null);

  // useClickAway(() => setOpen(false), ref);

  useEffect(() => ref.current?.focus(), [open]);

  useEffect(() => {
    document.addEventListener('keydown', event => handleKeyEvent(event, 'Escape', () => setOpen(false)));
  }, []);

  if (!open) return null;

  return (
    <ModalBackdrop blur={blur}>
      <ClickAwayListener
        onClickAway={event => {
          event.preventDefault(); // Note: as far as I know this is only needed for touch based devices (clicking away from the modal would trigger the touch event on the clicked area, which could be a button or table row for example)
          setOpen(false);
        }}
        mouseEvent={'onMouseDown'}
      >
        <dialog ref={ref} open={open} className='rounded-4 focus:outline-none' tabIndex={0}>
          {children}
        </dialog>
      </ClickAwayListener>
    </ModalBackdrop>
  );
}
